import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_DOMAIN from "../config/config"; // Ensure this path is correct

const Register = ({ selectedPlans, onBack, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    alternate_phone_number: "",
    address: "",
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!selectedPlans || selectedPlans.length === 0) {
      toast.error("No plans selected.");
      return;
    }
    try {
      const response = await fetch(`${API_DOMAIN}/register.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          reg_id: "REG" + Math.floor(1000 + Math.random() * 9000),
          name: formData.name,
          phone_number: formData.phone_number,
          alternate_phone_number: formData.alternate_phone_number,
          address: formData.address,
          choose_plans: JSON.stringify(selectedPlans), // Store full plans as JSON string
        }),
      });

      const data = await response.json();

      if (data.head.code === 200) {
        // No toast, trigger success modal in parent
        onSuccess();
        setFormData({
          name: "",
          phone_number: "",
          alternate_phone_number: "",
          address: "",
        });
        onBack();
      } else {
        toast.error(data.head.msg);
      }
    } catch (error) {
      toast.error("Connection Error");
    }
  };

  const plansSummary = selectedPlans.map((plan) => plan.scheme_name).join(", ");

  return (
    <Container className="py-5">
      <ToastContainer position="top-center" autoClose={3000} />
      <Row className="justify-content-center">
        <Col lg={6}>
          <Button
            variant="link"
            onClick={onBack}
            className="mb-3 text-dark text-decoration-none fw-bold fs-5"
          >
            <i className="fas fa-arrow-left me-2"></i> Back to Plans
          </Button>
          <Card
            className="shadow-lg border-0 rounded-4 "
            style={{ backgroundColor: "#e3f2fd" }}
          >
            <Card.Body className="p-4 p-lg-5">
              <h2 className="fw-bold text-center mb-4">
                Register for Plans: {plansSummary}
              </h2>
              <Form onSubmit={handleRegister}>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    name="phone_number"
                    value={formData.phone_number}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Alternate Phone Number</Form.Label>
                  <Form.Control
                    name="alternate_phone_number"
                    value={formData.alternate_phone_number}
                    onChange={handleInputChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="address"
                    rows={3}
                    value={formData.address}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
                <Button
                  type="submit"
                  className="w-100 py-3 fw-bold rounded-pill shadow border-0"
                  style={{
                    background: "linear-gradient(45deg, #aa62edff, #6285edff)",
                    color: "white",
                  }}
                >
                  Register Now
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;
